import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { border } from './primitive/border';
import {
  surface,
  gray,
  highlight,
  focus,
  formField,
  text,
  anchor,
  overlay,
  list,
  mask,
} from './semantic';
import {
  badge,
  button,
  datatable,
  datepicker,
  multiselect,
  tabs,
  card,
  autocomplete,
  accordion,
  tree,
  treeselect,
  tag,
} from './components';

const primaryLight = {
  primary: {
    color: '{primary.500}',
    inverseColor: '#ffffff',
    hoverColor: '{primary.600}',
    activeColor: '{primary.700}',
  },
};

const tourfoldLightTheme = definePreset(Aura, {
  primitive: {
    ...border,
  },
  semantic: {
    // ...greenPrimary,
    colorScheme: {
      light: {
        ...primaryLight,
        ...surface,
        ...gray,
        ...highlight,
        ...focus,
        ...formField,
        ...text,
        ...anchor,
        ...overlay,
        ...list,
        ...mask,
      },
    },
  },
  components: {
    ...button,
    ...multiselect,
    ...tabs,
    ...datatable,
    ...datepicker,
    ...badge,
    ...card,
    ...autocomplete,
    ...accordion,
    ...tree,
    ...treeselect,
    ...tag,
  },
});

export default tourfoldLightTheme;
